module.exports = __webpack_public_path__ + "static/img/wuyanzu.d06a09d2.jpg";